<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" :placeholder="kind === 2 ? '发票名称' : '发票抬头/发票税号'" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.small_project_id" clearable filterable placeholder="零星项目">
                                        <Option :value="item.small_project_id" v-for="(item,index) in projectList" :key="index">{{item.customer_name ? item.name + '（' + item.customer_name + '）' : item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.inv_type" clearable filterable placeholder="发票类型">
                                        <Option :value="item.id" v-for="(item,index) in invTypeList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.apply_id" clearable filterable placeholder="申请人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.status" clearable placeholder="状态" class="search-select">
                                        <Option :value="item.id" v-for="(item,index) in statusList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> {{kind === 2 ? '添加发票' : '开发票'}}</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="invoice_id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" no-data-text="暂无数据记录">
                                <!-- 收入发票：发票抬头 -->
                                <template #inv_head="{ row }" v-if="kind === 1">
                                    <div class="d-width cursor text-primary" :title="row.inv_head" @click="showData(row.invoice_id)">
                                        <span>{{row.inv_head}}</span>
                                    </div>
                                </template>
                                <!-- 支出发票：发票名称 -->
                                <template #title="{ row }" v-else>
                                    <div class="d-width cursor text-primary" :title="row.title" @click="showData(row.invoice_id)">
                                        <span>{{row.title}}</span>
                                    </div>
                                </template>
                                <template #inv_num="{ row }">
                                    <div class="d-width" :title="row.inv_num">
                                        <span>{{row.inv_num ?? '-'}}</span>
                                    </div>
                                </template>
                                <template #inv_type="{ row }">
                                    <Tag color="blue">{{row.inv_type_name}}</Tag>
                                </template>
                                <template #inv_money="{ row }">
                                    <span class="text-primary">{{row.inv_money}}</span>
                                </template>
                                <template #use_inv_money="{ row }">
                                    <span class="text-orange">{{row.use_inv_money}}</span>
                                </template>
                                <template #get_money="{ row }">
                                    <span class="text-success">{{row.get_money}}</span>
                                </template>
                                <template #inv_company="{ row }">
                                    <div class="d-width" :title="row.inv_company_name">
                                        <span>{{row.inv_company_name ?? '-'}}</span>
                                    </div>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                                    <Poptip v-else-if="row.status === 2" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                        <Badge color="red" :text="row.status_name" />
                                        <template #content>
                                            <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                            <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                        </template>
                                    </Poptip>
                                    <Badge v-else-if="row.status === 3" color="green" :text="row.status_name" />
                                    <Badge v-else color="#999999" text="其他" />
                                </template>
                                <!-- 收款编号（收入） -->
                                <template #income_sn="{ row }">
                                    <span class="text-999" v-if="row.income_sn.length <= 0">未绑定</span>
                                    <div v-else>
                                        <Tag class="cursor" v-for="(item,idx) in row.income_sn" :key="idx" color="orange" @click="showRecord(item.id)">{{item.sn}}</Tag>
                                    </div>
                                </template>
                                <!-- 支出记录（支出） -->
                                <template #expend_sn="{ row }">
                                    <span class="text-999" v-if="row.expend_sn.length <= 0">未绑定</span>
                                    <div v-else>
                                        <Tag class="cursor" v-for="(item,idx) in row.expend_sn" :key="idx" color="orange" @click="showRecord(item.id)">{{item.sn}}</Tag>
                                    </div>
                                </template>
                                <template #apply_id="{ row }">
                                    <div class="d-width" :title="row.apply_name">
                                        <span>{{row.apply_name}}</span>
                                    </div>
                                </template>
                                <template #remark="{ row }">
                                    <div class="d-width" :title="row.remark">
                                        <span>{{row.remark ?? '-'}}</span>
                                    </div>
                                </template>
                                <template #action="{ row, index }">
                                    <a class="text-font-sm text-orange" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 1" @click="examineData(row.invoice_id)">开票/审批</a>
                                    <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 1"/>
                                    <a class="text-font-sm text-orange" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 3 && parseFloat(row.inv_money) > parseFloat(row.use_inv_money)" @click="bindData(row.invoice_id)">绑定</a>
                                    <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 3 && parseFloat(row.use_inv_money) > 0 && parseFloat(row.inv_money) > parseFloat(row.use_inv_money)"/>
                                    <a class="text-font-sm text-primary" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 3 && parseFloat(row.use_inv_money) > 0" @click="clearData(row.invoice_id)">清空</a>
                                    <Divider type="vertical" v-if="row.status === 3 && parseFloat(row.use_inv_money) > 0"/>
                                    <a class="text-font-sm text-primary" @click="editData(row.invoice_id)">编辑</a>
                                    <Divider type="vertical" v-if="row.status !== 3 && parseFloat(row.use_inv_money) <= 0"/>
                                    <a class="text-font-sm text-danger" v-if="row.status !== 3 && parseFloat(row.use_inv_money) <= 0" @click="deleteData(row.invoice_id, index)">删除</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" :kind="kind" @trueHandler="saveData"></add-modal>

                    <!-- 开票审批  -->
                    <examine-modal v-if="is_examine" ref="ExamineRef" :kind="kind" @trueHandler="saveData"></examine-modal>

                    <!-- 发票详情  -->
                    <show-modal v-if="is_show" ref="ShowRef" :kind="kind"></show-modal>

                    <!-- 绑定收款  -->
                    <income-bind-modal v-if="is_income_bind" ref="IncomeBindRef" @trueHandler="saveData"></income-bind-modal>

                    <!-- 绑定支出  -->
                    <expend-bind-modal v-if="is_expend_bind" ref="ExpendBindRef" @trueHandler="saveData"></expend-bind-modal>

                    <!-- 收款详情  -->
                    <income-show-modal v-if="is_income_show" ref="IncomeShowRef"></income-show-modal>

                    <!-- 支出详情  -->
                    <expend-show-modal v-if="is_expend_show" ref="ExpendShowRef"></expend-show-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "./InvoiceCreate";
import ExamineModal from "./InvoiceExamine";
import ShowModal from "./InvoiceShow";
import IncomeBindModal from "./IncomeBind";
import ExpendBindModal from "./ExpendBind";
import IncomeShowModal from "./IncomeShow";
import ExpendShowModal from "./ExpendShow";
import {deleteDispersedInvoice, getDispersedInvoiceConfig, getDispersedInvoiceList, clearDispersedInvoice} from "@/apis/dispersed";
export default {
    name: "DispersedInvoice",
    components: {
        Headers, Side, AddModal, ExamineModal, ShowModal, IncomeBindModal, ExpendBindModal, IncomeShowModal, ExpendShowModal
    },
    props: {
        kind: {
            type: [Number, String],
            default: 1
        }
    },
    data () {
        return {
            projectList: [],
            invTypeList: [],
            userList: [],
            statusList: [],

            search: {
                name: '',
                small_project_id: '',
                inv_type: '',
                apply_id: '',
                status: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            is_create : false,
            is_examine : false,
            is_show : false,
            is_income_bind : false,
            is_expend_bind : false,
            is_income_show : false,
            is_expend_show : false,
        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {
        /**
         * 功能：列配置（收入/支出分别对齐系统发票列）
         * time: 2026/09/13
         **/
        columns(){
            if(parseInt(this.kind) === 2){
                //支出发票
                return [
                    { title: '发票名称', key: 'title', slot: 'title', fixed:'left', minWidth: 180 },
                    { title: '开票金额', key: 'inv_money', slot: 'inv_money', width: 120 },
                    { title: '已绑金额', key: 'use_inv_money', slot: 'use_inv_money', width: 120 },
                    { title: '发票类型', key: 'inv_type', slot: 'inv_type', width: 120 },
                    { title: '开票公司', key: 'inv_company', slot: 'inv_company', minWidth: 180 },
                    { title: '状态', key: 'status', slot: 'status', width: 100 },
                    { title: '支出记录', key: 'expend_sn', slot: 'expend_sn', minWidth: 160 },
                    { title: '申请人', key: 'apply_id', slot: 'apply_id', width: 100 },
                    { title: '备注', key: 'remark', slot: 'remark', minWidth: 120 },
                    { title: '#', key: 'action', slot : 'action', fixed : 'right', width : 180 }
                ];
            }
            //收入发票
            return [
                { title: '发票抬头', key: 'inv_head', slot: 'inv_head', fixed:'left', minWidth: 180 },
                { title: '发票税号', key: 'inv_num', slot: 'inv_num', minWidth: 150 },
                { title: '发票类型', key: 'inv_type', slot: 'inv_type', width: 120 },
                { title: '开票金额', key: 'inv_money', slot: 'inv_money', width: 120 },
                { title: '已绑金额', key: 'use_inv_money', slot: 'use_inv_money', width: 120 },
                { title: '到账金额', key: 'get_money', slot: 'get_money', width: 120 },
                { title: '开票公司', key: 'inv_company', slot: 'inv_company', minWidth: 140 },
                { title: '状态', key: 'status', slot: 'status', width: 100 },
                { title: '收款编号', key: 'income_sn', slot: 'income_sn', minWidth: 160 },
                { title: '申请人', key: 'apply_id', slot: 'apply_id', width: 100 },
                { title: '备注', key: 'remark', slot: 'remark', minWidth: 120 },
                { title: '#', key: 'action', slot : 'action', fixed : 'right', width : 180 }
            ];
        }
    },
    methods: {
        /**
         * 功能：搜索
         * time: 2026/09/12
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         * 功能：刷新
         * time: 2026/09/12
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                name: '',
                small_project_id: '',
                inv_type: '',
                apply_id: '',
                status: ''
            };
            that.getList();
        },
        /**
         * 功能：配置
         * time: 2026/09/12
         **/
        getConfig(){
            let that = this;
            getDispersedInvoiceConfig().then(e=>{
                that.projectList = e.data.projectList ?? [];
                that.invTypeList = e.data.invTypeList ?? [];
                that.userList = e.data.userList ?? [];
                that.statusList = e.data.statusList ?? [];
            })
        },
        /**
         * 功能：列表
         * time: 2026/09/12
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                kind : parseInt(that.kind),
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getDispersedInvoiceList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         * 功能：分页
         * time: 2026/09/12
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },
        /**
         * 功能：创建
         * time: 2026/09/12
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         * 功能：编辑
         * time: 2026/09/12
         **/
        editData(invoice_id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(invoice_id);
            })
        },
        /**
         * 功能：详情
         * time: 2026/09/12
         **/
        showData(invoice_id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowRef.show(invoice_id);
            })
        },
        /**
         * 功能：开票审批
         * time: 2026/09/12
         **/
        examineData(invoice_id){
            let that = this;
            that.is_examine = true;
            setTimeout(function(){
                that.$refs.ExamineRef.show(invoice_id);
            })
        },
        /**
         * 功能：操作返回
         * time: 2026/09/12
         **/
        saveData(){
            let that = this;
            that.getList();
        },
        /**
         * 功能：删除
         * time: 2026/09/12
         **/
        deleteData(invoice_id, index){
            let that = this;
            if(!invoice_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteDispersedInvoice(invoice_id).then( e =>{
                        that.dataList.data.splice(index , 1);
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                    })
                },
                onCancel: () => {}
            });
        },
        /**
         * 功能：绑定
         * time: 2026/09/13
         **/
        bindData(invoice_id){
            let that = this;
            if(parseInt(that.kind) === 1){
                that.is_income_bind = true;
                setTimeout(function(){
                    that.$refs.IncomeBindRef.show(invoice_id);
                })
            }else{
                that.is_expend_bind = true;
                setTimeout(function(){
                    that.$refs.ExpendBindRef.show(invoice_id);
                })
            }
        },
        /**
         * 功能：打开收款/支出详情
         * time: 2026/09/13
         **/
        showRecord(record_id){
            let that = this;
            if(!record_id) return;
            if(parseInt(that.kind) === 1){
                that.is_income_show = true;
                setTimeout(function(){
                    that.$refs.IncomeShowRef.show(record_id);
                })
            }else{
                that.is_expend_show = true;
                setTimeout(function(){
                    that.$refs.ExpendShowRef.show(record_id);
                })
            }
        },
        /**
         * 功能：清空绑定
         * time: 2026/09/13
         **/
        clearData(invoice_id){
            let that = this;
            if(!invoice_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '清空绑定记录',
                content: '此操作将清空绑定记录不可恢复, 是否继续?',
                onOk: () => {
                    clearDispersedInvoice(invoice_id).then( e =>{
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                        that.getList();
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
